var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgAverageIcon = function SvgAverageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 5655",
    width: 29.204,
    height: 29.204
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 365",
    cx: 14.574,
    cy: 14.574,
    transform: "translate(.056)",
    fill: "#fdd402",
    r: 14.574
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3830",
    d: "M3.991 14.6A14.6 14.6 0 0116.6.136a14.6 14.6 0 100 28.931A14.6 14.6 0 013.991 14.6z",
    fill: "#fbbf13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3831",
    d: "M8.582 13.538a2.364 2.364 0 01-2.362-2.361.5.5 0 111 0 1.364 1.364 0 002.728 0 .5.5 0 111 0 2.364 2.364 0 01-2.366 2.361zm12.041 0a2.364 2.364 0 01-2.362-2.362.5.5 0 011 0 1.364 1.364 0 002.727 0 .5.5 0 111 0 2.364 2.364 0 01-2.368 2.362zm-.033 7.983H8.615a.5.5 0 010-1h11.974a.5.5 0 010 1z",
    fill: "#74563a"
  })));
};
export default SvgAverageIcon;